import React from 'react';

import { Box, Text } from 'components';

const Press = props => {
  // quick for mockup
  const articles = [
    {
      hero: 'yahoo-finance.png',
      title: 'Crypto-backed music streaming platform rewards listeners',
      date: 'May 20 - 5 min video',
      subtitle: 'Dan\'s interview on Yahoo! Finance.',
      url:
        'https://finance.yahoo.com/video/crypto-backed-music-streaming-platform-192716374.html',
    },
    {
      hero: 'nbc-chicago.png',
      title: 'Tech Trends: Listening Pays Off With \'Current\' App',
      subtitle: 'Dan\'s interview with NBC Chicago.',
      date: 'April 28 - 3 min video',
      url:
        'https://www.nbcchicago.com/on-air/as-seen-on/current-app-crypto-points-509179722.html',
    },
    {
      hero: 'cnbc.png',
      title: 'Where\'s bitcoin headed?',
      subtitle: 'Dan discusses the direction of bitcoin with CNBC.',
      date: 'Dec 10 - 2 min video',
      url:
        'https://www.cnbc.com/video/2017/12/10/wheres-bitcoin-headed.html',
    },
    {
      hero: 'cnbc-sept.jpg',
      title: 'How a new class of startups are using blockchain to tackle some of the Internet’s biggest challenges',
      subtitle: 'Article from CNBC.',
      date: 'Sep 8 - 3 min read',
      url:
        'https://www.cnbc.com/2018/09/08/media-meets-crypto-how-blockchain-based-media-is-compensating-users.html',
    },
    {
      hero: 'bloomberg.png',
      title: 'YouTube and Facebook Are Losing Creators to Blockchain-Powered Rivals',
      subtitle: 'Bloomberg discussed how Current is poised to disrupt incumbent media platforms.',
      date: 'April 10 - 7 min read',
      url:
        'https://www.bloomberg.com/news/articles/2018-04-10/youtube-and-facebook-are-losing-creators-to-blockchain-powered-rivals',
    },
    {
      hero: 'cheddar.png',
      title: 'Cheddar interview with Current CEO, Dan Novaes',
      subtitle: 'Dan talks about the CRNC Project with Cheddar TV.',
      date: 'Mar 7 - 7 min video',
      url:
        'https://www.youtube.com/watch?v=11XVV1wPMog',
    },
    {
      hero: 'cgtn.png',
      title: 'Dan Novaes discusses the future of blockchain and cryptocurrency',
      subtitle: 'CGTN\'s Rachelle Akuffo spoke to Dan Novaes, CEO of Current, about the future of cryptocurrencies and blockchain technology.',
      date: 'Feb 5 - 5 min video',
      url:
        'https://www.youtube.com/watch?v=y0X3aQdZKzM',
    },
    {
      hero: 'blockchain-news.jpg',
      title: 'Current Media Closes $36m Private Sale, Readies Airdrop',
      subtitle: 'Article from BlockchainNews.',
      date: 'Feb 6 - 2 min read',
      url:
        'https://www.the-blockchain.com/2018/02/06/current-media-closes-36m-private-sale-readies-airdrop/',
    },
    {
      hero: 'cryptoslate.png',
      title: 'Current (CRNC) Will Reward Users During Media Streaming',
      subtitle: 'While people are consuming more media than ever before, the ways that they are doing so is changing. Our lives are increasingly mobile and digital, which has given rise to new opportunities for content consumption...',
      date: 'Feb 14 - 5 min read',
      url: 'https://cryptoslate.com/ico-watch-current-crnc-will-reward-users-media-streaming/',
    }
  ];

  return (
    <Box mb="5">
      <Text display="h1">Press Mentions</Text>
      <Box flex justifyContent="between" style={{ overflowX: 'auto' }}>
        {articles.map(article => {
          const heroImage = require(`../../images/${article.hero}`);
          return (
            <a
              className="press-update"
              href={article.url}
              key={article.hero}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Box>
                <Box
                  className="press-update-hero"
                  style={{ backgroundImage: `url(${heroImage})`}}
                />
                <Text display="h4">{article.title}</Text>
                <Text>{article.subtitle}</Text>
                <Box>
                  <small>{article.date}</small>
                </Box>
              </Box>
            </a>
          );
        })}
      </Box>
    </Box>
  );
};

export default Press;
